export default "__VITE_ASSET__BWKvh0eu__"